import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField
} from "@material-ui/core";
import {
  ArrowBack,
  ArrowDropDown,
  Battery80,
  NetworkWifiOutlined,
  SearchOutlined,
  SignalCellularAltOutlined
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { FormattedMessage } from "react-intl";

import { CollectionDetailsPageFormData } from "../CollectionDetailsPage";

const useStyles = makeStyles(
  {
    action: {
      display: "flex",
      justifyContent: "center"
    },
    battery: {
      transform: "rotate(90deg)"
    },
    close: {
      "& span": {
        color: "#0030FF"
      },
      border: "1px solid #EAEAEA",
      borderRadius: "10px",
      padding: "10px 35px 10px 35px"
    },
    header: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "10px"
    },
    icon: {
      width: "inherit"
    },
    iconContainer: {
      display: "inline-block",
      height: "80px",
      marginRight: "24px",
      width: "84px"
    },
    main: {
      color: "white",
      height: "207px",
      marginLeft: "10px",
      marginRight: "10px",
      marginTop: "10px"
    },
    misc: {
      alignItems: "center",
      display: "flex",
      height: "80px",
      justifyContent: "space-between",
      paddingLeft: "20px",
      paddingRight: "20px"
    },
    paper: {
      backgroundColor: "white",
      borderRadius: "20px",
      display: "flex",
      height: "40px",
      left: "30px",
      position: "absolute",
      width: "90%"
    },
    search: {
      alignItems: "center",
      display: "inline-flex",
      gap: "10px",
      marginTop: "10px",
      paddingBottom: "15px",
      paddingLeft: "15px",
      paddingRight: "15px",
      width: "100%"
    },
    searchBox: {
      "& .MuiInputBase-root": {
        borderRadius: "10px !important"
      },
      "& div": {
        "& input": {
          padding: "15px 12px 15px 12px"
        }
      }
    },
    title: {
      alignItems: "center",
      display: "inline-flex",
      gap: "5px"
    }
  },
  { name: "CollectionPreviewDialog" }
);

export interface CollectionPreviewDialogProps {
  data: CollectionDetailsPageFormData;
  open: boolean;
  onClose: () => void;
  backgroundColor: string;
  iconImage: any;
}

const CollectionPreviewDialog: React.FC<CollectionPreviewDialogProps> = props => {
  const { backgroundColor, open, onClose, iconImage, data } = props;

  const classes = useStyles(props);

  //   React.useEffect(() => {
  //     console.log(iconImage);
  //   }, [iconImage]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Header Preview</DialogTitle>
      <DialogContent>
        <div className={classes.main} style={{ backgroundColor }}>
          <div className={classes.header}>
            <div>
              <span>9:41</span>
            </div>
            <div>
              <SignalCellularAltOutlined />
              <NetworkWifiOutlined />
              <Battery80 className={classes.battery} />
            </div>
          </div>
          <div className={classes.search}>
            <div>
              <ArrowBack />
            </div>
            <TextField
              defaultValue={"Search in Cyberzone"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlined />
                  </InputAdornment>
                )
              }}
              className={classes.searchBox}
              fullWidth
            />
          </div>
          <div className={classes.misc}>
            <div className={classes.title}>
              <h1>Cyberzone</h1>
              <ArrowDropDown width={30} height={30} />
            </div>
            <div className={classes.iconContainer}>
              {iconImage || data.iconImage?.url ? (
                <img
                  className={classes.icon}
                  src={iconImage ? iconImage : data.iconImage.url}
                />
              ) : (
                <span></span>
              )}
            </div>
          </div>
          <div className={classes.paper}></div>
        </div>

        <DialogActions className={classes.action}>
          <div>
            <Button className={classes.close} onClick={onClose}>
              <FormattedMessage defaultMessage="Close" description="button" />
            </Button>
          </div>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

CollectionPreviewDialog.displayName = "CollectionPreviewDialog";
export default CollectionPreviewDialog;
